import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { updateOfficeKey } from '../actions/index';
import ContactInfo from '../common/components/contactInfo/ContactInfo';
import LandingPhoto from '../common/components/landingPhoto/LandingPhoto';
import OfficeInfo from '../common/components/officeInfo/OfficeInfo';
import SelectOffice from '../common/components/selectOffice/SelectOffice';
import { ContactInfoType, InfoTLDType, OficceInfoType } from '../types';

export interface PageProps {
    infoOffice: OficceInfoType;
    onChangeOffice: Function;
    infoTLD: ContactInfoType;
}
export interface PropsStructure {
    infoOffice: OficceInfoType;
    infoTLD: InfoTLDType;
}

const Page = ({ infoOffice, onChangeOffice, infoTLD }: PageProps) => (
    <>
        <OfficeInfo infoOffice={infoOffice} />
        <SelectOffice onChangeOffice={onChangeOffice} />
        <ContactInfo infoTLD={infoTLD} />
        <LandingPhoto location={infoOffice.location} />
    </>
);

const _mapStateToProps = ({ infoOffice, infoTLD }: PropsStructure) => {
    return {
        infoOffice,
        infoTLD,
    };
};

const _mapDispatchToProps = (dispatch: Dispatch<string>) => {
    return {
        onChangeOffice: (office: string) => {
            dispatch(updateOfficeKey(office));
        },
    };
};

export default connect(_mapStateToProps, _mapDispatchToProps)(Page);
